import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { X, Gift } from "lucide-react";
import { api } from "@/lib/api";
import { useUi } from "@/lib/uiConfig";
import { whenFree } from "@/lib/popupQueue";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const trackWa = (event, source) => api.post("/whatsapp/track", { event, source }).catch(() => {});

export function WhatsAppNewbieHint() {
  const ui = useUi();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!ui?.whatsapp_link) return undefined;
    let alive = true;
    const t = setTimeout(() => api.get("/whatsapp/hint").then(({ data }) => {
      if (alive && data.show) whenFree("wa-newbie-hint", () => { setOpen(true); trackWa("hint_shown", "hint"); });
    }).catch(() => {}), 8000);
    return () => { alive = false; clearTimeout(t); };
  }, [ui?.whatsapp_link]);
  if (!open || pathname === "/gemeinsam-punkte-sammeln") return null;
  const close = () => { setOpen(false); trackWa("hint_dismiss", "hint"); };
  const go = () => { setOpen(false); trackWa("hint_open", "hint"); navigate("/gemeinsam-punkte-sammeln?von=hinweis"); };
  return (
    <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-3 bg-slate-900/30 backdrop-blur-[2px] wa-hint-fade" role="dialog" aria-modal="true" aria-label="WhatsApp-Gruppe" data-testid="wa-newbie-hint" onClick={close}>
      <div className="wa-hint-sheet relative w-full max-w-sm rounded-[1.75rem] bg-white p-5 pt-6 shadow-2xl ring-1 ring-emerald-100 text-center" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={close} aria-label="Schließen" data-testid="wa-hint-close" className="absolute top-3 right-3 w-9 h-9 rounded-full bg-slate-100 text-slate-500 flex items-center justify-center hover:bg-slate-200"><X className="w-4 h-4" /></button>
        <span className="relative mx-auto w-16 h-16 rounded-2xl wa-btn flex items-center justify-center shadow-xl shadow-emerald-300/50">
          <WhatsAppIcon className="w-9 h-9 text-white" />
          <span className="wa-gift absolute -top-2 -right-2 w-7 h-7 rounded-full bg-amber-300 text-amber-900 flex items-center justify-center shadow"><Gift className="w-4 h-4" /></span>
        </span>
        <h2 className="mt-4 font-display text-xl font-black text-slate-900">Schön, dass du da bist! 💚</h2>
        <p className="mt-2 text-sm text-slate-600">In unserer WhatsApp-Gruppe sammeln Mitglieder gemeinsam Punkte, teilen Tipps und helfen sich bei Fragen – gerade am Anfang super praktisch.</p>
        <button type="button" onClick={go} data-testid="wa-hint-open" className="tap wa-btn relative mt-5 w-full h-12 rounded-full text-white font-extrabold inline-flex items-center justify-center gap-2"><WhatsAppIcon className="w-5 h-5" /> Gruppe ansehen</button>
        <button type="button" onClick={close} data-testid="wa-hint-later" className="mt-2 w-full h-10 rounded-full text-sm font-bold text-slate-500 hover:text-slate-700">Vielleicht später</button>
        <p className="mt-1 text-[11px] text-slate-400">Freiwillig – du kannst die Community auch ohne Gruppe voll nutzen.</p>
      </div>
    </div>
  );
}
